import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useTranslation } from 'react-i18next'
import { toNote } from '@/lib/link'
import Content from './Content'

export default function ChatMessagePreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()

  return (
    <div className={cn('pointer-events-none', className)}>
      [{t('Chat message')}]{' '}
      <a href={toNote(event)} onClick={(e) => e.preventDefault()}>
        <Content event={event} className="italic pr-0.5" />
      </a>
    </div>
  )
}
